import React from 'react';
import Reveal from '../components/Reveal';
import ProductBox from '../components/ProductBox';
import FlavourSelector from '../components/FlavourSelector';
import { Personalities } from './home/Lifestyle';
import Quiz from './home/Quiz';
import MixBox from './home/MixBox';
import { Purchase } from './home/Purchase';
import { useFlavour } from '../context/FlavourContext';

export default function Flavours() {
  const { flavour, order } = useFlavour();
  return (
    <div className="pt-24">
      <section className="relative py-14 md:py-20 overflow-hidden">
        <div className="flavour-transition absolute inset-0 -z-10" style={{ background: `radial-gradient(ellipse 60% 50% at 70% 40%, rgba(${flavour.rgb},0.18), transparent 70%), #050505` }} />
        <div className="max-w-[1400px] mx-auto px-5">
          <Reveal className="text-center">
            <p className="font-cond tracking-[0.3em] text-white/40 mb-3">SAME POWER. DIFFERENT TASTE.</p>
            <h1 className="font-display text-5xl md:text-8xl">FIND YOUR<br /><span className="text-flavour flavour-transition">FLAVOUR</span></h1>
            <p className="text-white/60 mt-5">Six extraordinary flavours. One powerful formula. What's your S-MAN?</p>
          </Reveal>
          <div className="flex items-end justify-center gap-2 md:gap-5 my-12 flex-wrap">
            {order.map((id, i) => (<div key={id} style={{ transform: `translateY(${i%2?12:0}px)` }}><ProductBox flavourId={id} size="sm" glow={id===flavour.id} /></div>))}
          </div>
          <FlavourSelector source="flavours-page" />
        </div>
      </section>

      <Personalities />
      <Quiz />
      <MixBox />
      <Purchase />
    </div>
  );
}
